<!--
# -----------------------------------------------------------------------------
# Component: CreateDebitNote.vue
# Author: antonio.ramirez@pst.sg
# Created Date: 14/May/2019
# Comments: Page for Create Debit Note Functionality
# -----------------------------------------------------------------------------
-->
<template>
  <page>
    <v-container fluid grid-list-lg>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card>
            <v-toolbar v-if="this.debitNoteData.tranMode !== 'R'" dense color="grey lighten-3" flat>
              <v-icon>mdi-plus</v-icon>
              <v-toolbar-title>Create New Debit Note</v-toolbar-title>
            </v-toolbar>
            <v-toolbar v-if="this.debitNoteData.tranMode === 'R'" dense color="grey lighten-3" flat>
              <v-icon>mdi-pencil</v-icon>
              <v-toolbar-title>Edit Debit Note </v-toolbar-title>
            </v-toolbar>
            <v-tabs v-model="tabNav">
              <v-tab @click.native="doMandatory(0)">Mandatory</v-tab>
              <v-tab @click.native="doOptional(1)">Optional</v-tab>
            </v-tabs>
            <v-tabs-items v-model="tabNav" touchless>
              <v-tab-item transition="fade-transition" reverse-transition="fade-transition" key="mandatory" eager>
                <form data-vv-scope="debitNoteMandatoryForm">
                  <v-flex xs12>
                    <v-card>
                      <v-card-text>
                        <v-container fluid grid-list-lg>
                          <v-layout row wrap>
                            <v-flex md6 xs12>
                              <v-autocomplete
                                :items="branches"
                                v-model="debitNoteForm.branch"
                                :disabled="this.debitNoteData.tranMode === 'R'"
                                :label="debitNoteFormLabel.branch"
                                item-text="label"
                                item-value="value"
                                data-vv-name="debitNoteForm.branch"
                                :data-vv-as="debitNoteFormLabel.branch"
                                :error-messages="errors.collect('debitNoteForm.branch')"
                                clearable
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex md2 xs12 v-if="this.debitNoteData.tranMode !== 'R'">
                              <v-checkbox color="primary" :label="debitNoteFormLabel.docAE" v-model="debitNoteForm.docAE"></v-checkbox>
                            </v-flex>
                            <v-flex md4 xs12>
                              <v-text-field
                                v-model="debitNoteForm.documentNo"
                                :disabled="isDisableddocumentNo || this.debitNoteData.tranMode === 'R'"
                                :label="debitNoteFormLabel.documentNo"
                                :error-messages="errors.collect('debitNoteForm.documentNo')"
                                data-vv-name="debitNoteForm.documentNo"
                                :data-vv-as="debitNoteFormLabel.documentNo"
                                @blur="checkDocNo"
                                v-validate="docNoValidation"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md4 xs12>
                              <cal-picker
                                v-model="debitNoteForm.transactionDate"
                                :label="debitNoteFormLabel.transactionDate"
                                :data-vv-as="debitNoteFormLabel.transactionDate"
                                :error-messages="errors.collect('debitNoteForm.transactionDate')"
                                data-vv-name="debitNoteForm.transactionDate"
                                v-validate="doValidateTranDate"
                                :loading="loading"
                              ></cal-picker>
                            </v-flex>
                            <v-flex md5 xs12>
                              <v-autocomplete
                                :items="accounts"
                                v-model="debitNoteForm.accountNo"
                                item-text="label"
                                item-value="value"
                                :label="debitNoteFormLabel.accountNo"
                                :error-messages="errors.collect('debitNoteForm.accountNo')"
                                data-vv-name="debitNoteForm.accountNo"
                                :data-vv-as="debitNoteFormLabel.accountNo"
                                @change="getAcctInfo($event)"
                                v-validate="'required'"
                                clearable
                                :disabled="this.debitNoteData.tranMode === 'R'"
                              >
                                <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                  <v-icon
                                    color="info"
                                    @click="showAcctNoHelpList = true"
                                    v-text="'mdi-magnify'"
                                    :disabled="this.debitNoteData.tranMode === 'R'"
                                  ></v-icon>
                                </v-slide-x-reverse-transition>
                              </v-autocomplete>
                            </v-flex>
                            <v-flex md3 xs12>
                              <v-autocomplete
                                :items="funds"
                                v-model="debitNoteForm.fund"
                                item-text="label"
                                item-value="value"
                                :label="debitNoteFormLabel.fund"
                                :error-messages="errors.collect('debitNoteForm.fund')"
                                data-vv-name="debitNoteForm.fund"
                                :data-vv-as="debitNoteFormLabel.fund"
                                v-validate="'required'"
                                clearable
                              >
                                <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                  <v-icon color="info" @click="showFundHelpList = true" v-text="'mdi-magnify'"></v-icon>
                                </v-slide-x-reverse-transition>
                              </v-autocomplete>
                            </v-flex>
                            <v-flex md5 xs12>
                              <v-autocomplete
                                :items="acctnosuffixes60"
                                v-model="debitNoteForm.accountNoSuffix"
                                item-text="label"
                                item-value="value"
                                :label="debitNoteFormLabel.accountNoSuffix"
                                :error-messages="errors.collect('debitNoteForm.accountNoSuffix')"
                                data-vv-name="debitNoteForm.accountNoSuffix"
                                :data-vv-as="debitNoteFormLabel.accountNoSuffix"
                                v-validate="'required'"
                                clearable
                              >
                                <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                  <v-icon color="info" @click="showAcctSufHelpList = true" v-text="'mdi-magnify'"></v-icon>
                                </v-slide-x-reverse-transition>
                              </v-autocomplete>
                            </v-flex>
                            <v-flex md2 xs12>
                              <v-autocomplete
                                :items="gstIO"
                                v-model="debitNoteForm.gstIO"
                                :label="debitNoteFormLabel.gstIO"
                                item-text="label"
                                item-value="value"
                                data-vv-name="gstIO"
                                :data-vv-as="debitNoteFormLabel.gstIO"
                                :error-messages="errors.collect('gstIO')"
                                @change="changeGstIO($event)"
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex md3 xs12>
                              <v-autocomplete
                                :items="gstStatuses"
                                v-model="debitNoteForm.gstStatus"
                                :label="debitNoteFormLabel.gstStatus"
                                item-text="label"
                                item-value="value"
                                data-vv-name="gstStatus"
                                :data-vv-as="debitNoteFormLabel.gstStatus"
                                :error-messages="errors.collect('gstStatus')"
                                :disabled="isBlankGSTIO"
                                @change="changeGstRate($event)"
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex md2 xs12>
                              <v-text-field
                                v-model="debitNoteForm.gstRate"
                                :label="debitNoteFormLabel.gstRate"
                                disabled
                                hide-details:error-messages="errors.collect('debitNoteForm.gstRate')"
                                data-vv-name="debitNoteForm.gstRate"
                                :data-vv-as="debitNoteFormLabel.gstRate"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md4 xs12>
                              <v-autocomplete
                                :items="amountcurrencies"
                                v-model="debitNoteForm.amountCurr"
                                :label="debitNoteFormLabel.amountCurr"
                                item-text="label"
                                item-value="value"
                                :error-messages="errors.collect('debitNoteForm.amountCurr')"
                                data-vv-name="debitNoteForm.amountCurr"
                                :data-vv-as="debitNoteFormLabel.amountCurr"
                                v-validate="'required'"
                                clearable
                              >
                                <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                  <v-icon color="info" @click="showCurrencyHelpList = true" v-text="'mdi-magnify'"></v-icon>
                                </v-slide-x-reverse-transition>
                              </v-autocomplete>
                            </v-flex>
                            <v-flex md8 xs12>
                              <v-text-field
                                ref="amount"
                                v-model="debitNoteForm.amount"
                                :label="debitNoteFormLabel.amount"
                                :error-messages="errors.collect('debitNoteForm.amount')"
                                data-vv-name="debitNoteForm.amount"
                                :data-vv-as="debitNoteFormLabel.amount"
                                v-num-mask="{ negative: true, intScale: 13, decScale: 2 }"
                                v-validate="'required|mask_decimal:2|mask_max_value:9999999999999.99|mask_min_value:0.01'"
                                @blur="calculateAmount()"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md4 xs12>
                              <v-autocomplete
                                :items="currencies"
                                v-model="debitNoteForm.gstAmountCurr"
                                :label="debitNoteFormLabel.gstAmountCurr"
                                item-text="label"
                                item-value="value"
                                data-vv-name="debitNoteForm.gstAmountCurr"
                                :data-vv-as="debitNoteFormLabel.gstAmountCurr"
                                :error-messages="errors.collect('receipcreditNoteFormsForm.gstAmountCurr')"
                                disabled
                              />
                            </v-flex>
                            <v-flex md1 xs12>
                              <v-checkbox
                                color="primary"
                                :label="debitNoteFormLabel.gstAmountAE"
                                :disabled="isGstAmtAE"
                                v-model="debitNoteForm.gstAmountAE"
                                @change="calculateAmount()"
                              ></v-checkbox>
                            </v-flex>
                            <v-flex md7 xs12>
                              <v-text-field
                                ref="gstAmount"
                                v-model="debitNoteForm.gstAmount"
                                :label="debitNoteFormLabel.gstAmount"
                                :disabled="isGstAmt"
                                :error-messages="errors.collect('debitNoteForm.gstAmount')"
                                data-vv-name="debitNoteForm.gstAmount"
                                :data-vv-as="debitNoteFormLabel.gstAmount"
                                v-num-mask="{ negative: true, intScale: 13, decScale: 2 }"
                                v-validate="'mask_decimal:2|mask_max_value:9999999999999.99'"
                                @blur="calculateAmount()"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md4 xs12>
                              <v-autocomplete
                                :items="currencies"
                                v-model="debitNoteForm.netAmountCurr"
                                :label="debitNoteFormLabel.netAmountCurr"
                                item-text="label"
                                item-value="value"
                                data-vv-name="debitNoteForm.netAmountCurr"
                                :data-vv-as="debitNoteFormLabel.netAmountCurr"
                                :error-messages="errors.collect('receipcreditNoteFormsForm.netAmountCurr')"
                                disabled
                              />
                            </v-flex>
                            <v-flex md8 xs12>
                              <v-text-field
                                v-model="debitNoteForm.netAmount"
                                :label="debitNoteFormLabel.netAmount"
                                disabled
                                :error-messages="errors.collect('debitNoteForm.netAmount')"
                                data-vv-name="debitNoteForm.netAmount"
                                :data-vv-as="debitNoteFormLabel.netAmount"
                                v-num-mask="{ negative: true, intScale: 13, decScale: 2 }"
                                v-validate="'required|mask_decimal:2|mask_max_value:9999999999999.99|mask_min_value:0.01'"
                                @blur="calculateAmount()"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md4 xs12>
                              <v-autocomplete
                                :items="currencies"
                                v-model="debitNoteForm.netLocalAmountCurr"
                                :label="debitNoteFormLabel.netLocalAmountCurr"
                                item-text="label"
                                item-value="value"
                                data-vv-name="debitNoteForm.netLocalAmountCurr"
                                :data-vv-as="debitNoteFormLabel.netLocalAmountCurr"
                                :error-messages="errors.collect('receipcreditNoteFormsForm.netLocalAmountCurr')"
                                disabled
                              />
                            </v-flex>
                            <v-flex md1 xs12>
                              <v-checkbox
                                color="primary"
                                :label="debitNoteFormLabel.netAmountLocalAE"
                                v-model="debitNoteForm.netAmountLocalAE"
                                :disabled="matchBaseCurr"
                                @change="calculateAmount()"
                              ></v-checkbox>
                            </v-flex>
                            <v-flex md7 xs12>
                              <v-text-field
                                ref="netLocalAmount"
                                v-model="debitNoteForm.netLocalAmount"
                                :label="debitNoteFormLabel.netLocalAmount"
                                :disabled="isNetLocAmt || matchBaseCurr"
                                :error-messages="errors.collect('debitNoteForm.netLocalAmount')"
                                data-vv-name="debitNoteForm.netLocalAmount"
                                :data-vv-as="debitNoteFormLabel.netLocalAmount"
                                v-num-mask="{ negative: true, intScale: 13, decScale: 2 }"
                                v-validate="'mask_decimal:2|mask_max_value:9999999999999.99'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md6 xs12 sm6 lg6 v-if="isNew">
                              <v-subheader class="queryLabel">{{ debitNoteFormLabel.createdBy }}</v-subheader>
                              <div class="queryValue">{{ createdName + ' on ' + nowDT }}</div>
                            </v-flex>
                            <v-flex md6 xs12 sm6 lg6 v-else>
                              <v-subheader class="queryLabel">{{ debitNoteFormLabel.createdBy }}</v-subheader>
                              <div class="queryValue">{{ debitNoteForm.createdBy + ' on ' + debitNoteForm.createdDate }}</div>
                            </v-flex>
                            <v-flex md6 xs12 sm6 lg6 v-if="isNew">
                              <v-subheader class="queryLabel">{{ debitNoteFormLabel.modifiedBy }}</v-subheader>
                              <div class="queryValue">{{ createdName + ' on ' + nowDT }}</div>
                            </v-flex>
                            <v-flex md6 xs12 sm6 lg6 v-else>
                              <v-subheader class="queryLabel">{{ debitNoteFormLabel.modifiedBy }}</v-subheader>
                              <div class="queryValue">{{ debitNoteForm.modifiedBy + ' on ' + debitNoteForm.modifiedDate }}</div>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </form>
              </v-tab-item>
              <v-tab-item transition="fade-transition" reverse-transition="fade-transition" key="optional" eager>
                <form data-vv-scope="debitNoteOptionalForm">
                  <v-flex xs12>
                    <v-card>
                      <v-card-text>
                        <v-container fluid grid-list-lg>
                          <v-layout row wrap>
                            <v-flex xs12>
                              <div class="header-padding body-2">Document Details</div>
                            </v-flex>
                            <v-flex md6 xs12>
                              <v-autocomplete
                                :items="printDocOpts"
                                v-model="debitNoteForm.printDocument"
                                :label="debitNoteFormLabel.printDocument"
                                item-text="label"
                                item-value="value"
                                data-vv-name="debitNoteForm.printDocument"
                                :data-vv-as="debitNoteFormLabel.printDocument"
                                :error-messages="errors.collect('debitNoteForm.printDocument')"
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex md6 xs12>
                              <v-autocomplete
                                :items="addressToOpts"
                                v-model="debitNoteForm.addressTo"
                                :label="debitNoteFormLabel.addressTo"
                                item-text="label"
                                item-value="value"
                                data-vv-name="debitNoteForm.addressTo"
                                :data-vv-as="debitNoteFormLabel.addressTo"
                                :error-messages="errors.collect('debitNoteForm.addressTo')"
                                @change="promptRemoveNameAddr = true"
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex md7 xs12>
                              <v-text-field
                                v-model="debitNoteForm.policyNo"
                                :label="debitNoteFormLabel.policyNo"
                                :error-messages="errors.collect('debitNoteForm.policyNo')"
                                data-vv-name="debitNoteForm.policyNo"
                                :data-vv-as="debitNoteFormLabel.policyNo"
                                v-validate="'entry|max:60'"
                              >
                                <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                  <v-icon color="info" @click="showAcctPolicyHelpList = true" v-text="'mdi-magnify'"></v-icon>
                                </v-slide-x-reverse-transition>
                              </v-text-field>
                            </v-flex>
                            <v-flex md7 xs12>
                              <v-text-field
                                v-model="debitNoteForm.companyName"
                                :label="debitNoteFormLabel.companyName"
                                :error-messages="errors.collect('debitNoteForm.companyName')"
                                data-vv-name="debitNoteForm.companyName"
                                :data-vv-as="debitNoteFormLabel.companyName"
                                v-validate="'entry|max:100|sanction:' + sanctionName1Error"
                                @change="valSanction(debitNoteForm.companyName, '', 'sanctionName1Error')"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md12 xs12>
                              <v-text-field
                                v-model="debitNoteForm.docAddress1"
                                :label="debitNoteFormLabel.docAddress1"
                                :error-messages="errors.collect('debitNoteForm.docAddress1')"
                                data-vv-name="debitNoteForm.docAddress1"
                                :data-vv-as="debitNoteFormLabel.docAddress1"
                                v-validate="'max:60'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md12 xs12>
                              <v-text-field
                                v-model="debitNoteForm.docAddress2"
                                :label="debitNoteFormLabel.docAddress2"
                                :error-messages="errors.collect('debitNoteForm.docAddress2')"
                                data-vv-name="debitNoteForm.docAddress2"
                                :data-vv-as="debitNoteFormLabel.docAddress2"
                                v-validate="'max:60'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md12 xs12>
                              <v-text-field
                                v-model="debitNoteForm.docAddress3"
                                :label="debitNoteFormLabel.docAddress3"
                                :error-messages="errors.collect('debitNoteForm.docAddress3')"
                                data-vv-name="debitNoteForm.docAddress3"
                                :data-vv-as="debitNoteFormLabel.docAddress3"
                                v-validate="'max:60'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md12 xs12>
                              <v-text-field
                                v-model="debitNoteForm.docAddress4"
                                :label="debitNoteFormLabel.docAddress4"
                                :error-messages="errors.collect('debitNoteForm.docAddress4')"
                                data-vv-name="debitNoteForm.docAddress4"
                                :data-vv-as="debitNoteFormLabel.docAddress4"
                                v-validate="'max:60'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md7 xs12>
                              <v-text-field
                                v-model="debitNoteForm.postalCode"
                                :label="debitNoteFormLabel.postalCode"
                                :error-messages="errors.collect('debitNoteForm.postalCode')"
                                data-vv-name="debitNoteForm.postalCode"
                                :data-vv-as="debitNoteFormLabel.postalCode"
                                v-validate="'entry|numeric|max:8'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md12 xs12>
                              <v-text-field
                                v-model="debitNoteForm.details"
                                :label="debitNoteFormLabel.details"
                                :error-messages="errors.collect('debitNoteForm.details')"
                                data-vv-name="debitNoteForm.details"
                                :data-vv-as="debitNoteFormLabel.details"
                                v-validate="'entry|max:120'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md12 xs12>
                              <v-text-field
                                v-model="debitNoteForm.statementRef"
                                :label="debitNoteFormLabel.statementRef"
                                :error-messages="errors.collect('debitNoteForm.statementRef')"
                                data-vv-name="debitNoteForm.statementRef"
                                :data-vv-as="debitNoteFormLabel.statementRef"
                                v-validate="'entry|max:200'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                              <div class="header-padding body-2">Other Details</div>
                            </v-flex>
                            <v-flex md7 xs12>
                              <v-autocomplete
                                :items="departments"
                                v-model="debitNoteForm.department"
                                :label="debitNoteFormLabel.department"
                                item-text="label"
                                item-value="value"
                                data-vv-name="debitNoteForm.department"
                                :data-vv-as="debitNoteFormLabel.department"
                                v-validate="deptValidation"
                                :error-messages="errors.collect('debitNoteForm.department')"
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex md12 xs12>
                              <v-text-field
                                v-model="debitNoteForm.insuredName"
                                :label="debitNoteFormLabel.insuredName"
                                :error-messages="errors.collect('debitNoteForm.insuredName')"
                                data-vv-name="debitNoteForm.insuredName"
                                :data-vv-as="debitNoteFormLabel.insuredName"
                                v-validate="'entry|max:60'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md4 xs12>
                              <v-text-field
                                v-model="debitNoteForm.claimNo"
                                :label="debitNoteFormLabel.claimNo"
                                :error-messages="errors.collect('debitNoteForm.claimNo')"
                                data-vv-name="debitNoteForm.claimNo"
                                :data-vv-as="debitNoteFormLabel.claimNo"
                                v-validate="'entry|max:60'"
                              >
                                <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                  <v-icon color="info" @click="showClmHelpList = true" v-text="'mdi-magnify'"></v-icon>
                                </v-slide-x-reverse-transition>
                              </v-text-field>
                            </v-flex>
                            <v-flex md4 xs12>
                              <v-text-field
                                v-model="debitNoteForm.gstRegNo"
                                :label="debitNoteFormLabel.gstRegNo"
                                :error-messages="errors.collect('debitNoteForm.gstRegNo')"
                                data-vv-name="debitNoteForm.gstRegNo"
                                :data-vv-as="debitNoteFormLabel.gstRegNo"
                                v-validate="'entry|max:60'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md4 xs12>
                              <v-text-field
                                v-model="debitNoteForm.taxInvoiceNo"
                                :label="debitNoteFormLabel.taxInvoiceNo"
                                :error-messages="errors.collect('debitNoteForm.taxInvoiceNo')"
                                data-vv-name="debitNoteForm.taxInvoiceNo"
                                :data-vv-as="debitNoteFormLabel.taxInvoiceNo"
                                v-validate="'entry|max:60'"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </form>
              </v-tab-item>
            </v-tabs-items>

            <v-card-actions>
              <v-btn color="error" dark @click.prevent="doCancel">
                {{ actionLabel.cancel }}
                <v-icon dark right>mdi-exit-to-app</v-icon>
              </v-btn>
              <v-btn color="secondary" dark @click="showMatchLater = true">
                {{ actionLabel.matchLater }}
                <v-icon dark right>mdi-content-copy</v-icon>
              </v-btn>
              <v-btn color="info" dark @click.prevent="doSaveDebitNote('CREATE_MATCH_NOW')" :loading="submitting">
                {{ actionLabel.matchNow }}
                <v-icon dark right>mdi-content-copy</v-icon>
              </v-btn>
              <v-btn color="info" dark @click.prevent="doSaveDebitNote('CREATE_SAVE_REVIEW')" :loading="submitting">
                {{ actionLabel.saveAndReview }}
                <v-icon dark right>mdi-content-save</v-icon>
              </v-btn>
              <v-btn color="primary" dark @click.prevent="doSaveDebitNote('CREATE_SAVE_POST')" :loading="submitting">
                {{ actionLabel.saveAndPost }}
                <v-icon dark right>mdi-arrow-right-bold-box</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
        <v-flex xs12 v-if="this.debitNoteData.tranMode === 'R'">
          <!-- CBO Added: Oct-05-2020 Comments -->
          <v-container fluid grid-list-sm>
            <v-layout row wrap>
              <v-flex lg12 xs12 order-lg1 order-xs2>
                <common-comments :commentRefNo="this.commentRefNo" :commentTranType="this.commentTranType"></common-comments>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
      <v-dialog v-model="showAcctNoHelpList" width="1280px">
        <acct-no-help-list
          @close="showAcctNoHelpList = false"
          @assign-acct-info="assignAcctInfo"
          :boolRefresh="showAcctNoHelpList"
        ></acct-no-help-list>
      </v-dialog>

      <v-dialog v-model="showAcctSufHelpList" width="1280px">
        <acct-suf-help-list
          :acctNoSfxApplnInt="this.acctNoSfxApplnInt"
          @close="showAcctSufHelpList = false"
          @assign-acct-suf-info="assignAcctSufInfo"
        ></acct-suf-help-list>
      </v-dialog>

      <v-dialog v-model="showFundHelpList" width="1280px">
        <fund-help-list @close="showFundHelpList = false" @assign-fund="assignFund"></fund-help-list>
      </v-dialog>

      <v-dialog v-model="showCurrencyHelpList" width="1280px">
        <currency-help-list @close="showCurrencyHelpList = false" @assign-currency-info="assignCurrencyInfo"></currency-help-list>
      </v-dialog>

      <v-dialog v-model="showAcctPolicyHelpList" width="1280px">
        <acct-policy-help-list
          :accountNo="debitNoteForm.accountNo"
          :extraTranGrp="2"
          :boolPolRefresh="showAcctPolicyHelpList"
          @close="showAcctPolicyHelpList = false"
          @assign-policy-info="assignPolicyInfo"
        ></acct-policy-help-list>
      </v-dialog>

      <v-dialog v-model="showClmHelpList" width="1280px">
        <claim-help-list
          @close="showClmHelpList = false"
          @assign-claim-no="assignClaimNo"
          :boolRefresh="showClmHelpList"
          :accountNo="debitNoteForm.accountNo"
        ></claim-help-list>
      </v-dialog>

      <v-dialog v-model="processingFlag" persistent width="300">
        <v-card color="primary" dark>
          <v-card-text>
            Processing...
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="loadingFlag" persistent width="300">
        <v-card color="primary" dark>
          <v-card-text>
            Loading...
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
      <warning v-model="promptMsg" :label="errMsg" :showAcceptBtn="isWarning" @ok="acceptInterWarn = true"/>
      <v-dialog v-model="showErrorDialog" width="800px">
        <v-card>
          <v-card-title primary-title>
            <div>
              <div class="headline">System Information</div>
              <span class="grey--text">An error occurred when creating Debit Note.</span>
            </div>
          </v-card-title>
          <v-card-text>
            <div v-if="messages.length > 0" class="pb-3">
              <v-subheader>Error Details:</v-subheader>
              <ul class="showErrorMsgs">
                <li v-for="(error, index) in messages" :key="index">
                  {{ error.message }}
                </li>
              </ul>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click.native="showErrorDialog = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!--LYT Added: 2020-08-27  Sanction Partial Matched Names List -->
      <v-dialog v-model="showSanctionDialog" width="1280px">
        <sanction-partial-match-list :sanctionItems="sanctionPartialMatchItems" @close="showSanctionDialog = false"></sanction-partial-match-list>
      </v-dialog>
      <v-dialog v-model="showMatchLater" width="680px">
        <match-later
          :multiFundSfxCurr="miscacctparams.multiFundSfxCurr"
          :tranType="debitNoteForm.transactionType"
          :curr="debitNoteForm.amountCurr"
          :acctNo="debitNoteForm.accountNo"
          :fund="debitNoteForm.fund"
          :acctNoSfx="debitNoteForm.accountNoSuffix"
          :polNo="debitNoteForm.policyNo"
          :boolRefresh="showMatchLater"
          @close="showMatchLater = false"
          @assign-match-later-info="assignMatchLaterInfo"
        ></match-later>
      </v-dialog>
      <prompt-leave
        v-if="showPromptLeave"
        title="Debit Note"
        :tranMode="this.debitNoteData.tranMode"
        v-model="promptLeave"
        @exit="doExit"
        @saveAndExit="doSaveAndExit"
      ></prompt-leave>
      <confirm v-model="promptRemoveNameAddr" @ok="doRemoveNameAddr">
        {{ promptRemoveNameAddrMsg }}
      </confirm>
    </v-container>
  </page>
</template>

<script>
import routeMixin from '@/mixins/route'
import MessageMixin from '@/mixins/message'
import { debitNoteAjaxMixin } from '@/mixins/accounting/debitNote/debitNoteAjaxMixin'
import { debitNoteViewMixin } from '@/mixins/accounting/debitNote/debitNoteViewMixin'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import AcctNoHelpList from '@/components/core/common/dialog/AcctNoHelpList'
import AcctSufHelpList from '@/components/core/common/dialog/AcctSufHelpList'
import CurrencyHelpList from '@/components/core/common/dialog/CurrencyHelpList'
import AcctPolicyHelpList from '@/components/core/common/dialog/AcctPolicyHelpList'
import ClaimHelpList from '@/components/core/common/dialog/ClaimHelpList'
import FundHelpList from '@/components/core/common/dialog/FundHelpList'
import { promptOnExitMixin } from '@/mixins/common/promptOnExitMixin'
import PromptLeave from '@/components/core/common/prompt/PromptLeave'
import { formatPrice } from '@/utils/index'
import { removeFormatNumber } from '@/utils/number'
import { parseISO } from 'date-fns'
import { formatDisplayDate, formatDisplayDateTime2, removeTime } from '@/utils/date'
import SanctionPartialMatchList from '@/components/core/common/dialog/SanctionPartialMatchList'
import MatchLater from '../dialog/MatchLater'
import CommonComments from '@/components/core/accounting/CommonComments'
import isAfter from 'date-fns/isAfter'

export default {
  data() {
    return {
      tabNav: 0,
      acctNoSfxApplnInt: '60',
      actionLabel: {
        cancel: 'Cancel',
        saveAndReview: 'Save & Review',
        saveAndPost: 'Save & Post',
        matchNow: 'Match Now',
        matchLater: 'Match Later'
      },
      validStatus: {
        mandatory: true,
        optional: true
      },
      loading: false,
      loadingFlag: false,
      processingFlag: false,
      showErrorDialog: false,
      submitting: false,
      showPromptLeave: true,
      accounts: [],
      showAcctNoHelpList: false,
      accountdata: {},
      acctnosuffixes60: [],
      showAcctSufHelpList: false,
      amountcurrencies: [],
      showCurrencyHelpList: false,
      amountcurrencydata: {},
      showAcctPolicyHelpList: false,
      departments: [],
      miscacctparams: [],
      branches: [],
      funds: [],
      currencies: [],
      showClmHelpList: false,
      showFundHelpList: false,
      isMandatory: true,
      isOptional: false,
      trandaterange: {},
      gstStatuses: [],
      gstrate: '0.00',
      baseCurrency: '',
      showMatchLater: false,
      promptRemoveNameAddr: false,
      promptRemoveNameAddrMsg: 'Do you want to remove Name, Address(1-4), Postal Code?'
    }
  },
  watch: {
    displayErrorDialog: {
      handler: function(messages) {
        if (messages && messages.length > 0) {
          this.showErrorDialog = true
        }
      },
      deep: true
    },
    'tDateRange.effDate': function() {
      if (this.tDateRange.effDate !== '' && this.debitNoteData.tranMode === '') {
        this.loading = true
        this.getCommonData('gstrate', this.debitNoteForm.gstStatus, formatDisplayDateTime2(this.debitNoteForm.transactionDate)).then(result => {
          if (result) {
            this.loading = false
          }
        })
      }
    },
    'debitNoteForm.amountCurr': function() {
      if (this.debitNoteForm.amountCurr && this.debitNoteForm.transactionDate) {
        this.getCommonData('currencyrate', this.debitNoteForm.amountCurr, formatDisplayDateTime2(this.debitNoteForm.transactionDate))
      }
    },
    'debitNoteForm.transactionDate': function() {
      if (this.debitNoteForm.amountCurr && this.debitNoteForm.transactionDate) {
        this.getCommonData('currencyrate', this.debitNoteForm.amountCurr, formatDisplayDateTime2(this.debitNoteForm.transactionDate))
      }
    }
  },
  computed: {
    doValidateTranDate() {
      const minDate = this.tDateRange.effDate
      const today = this.tDateRange.expDate
      return 'required|valMinTranDate:' + minDate + '|valMaxTranDate:' + today
    },
    debitNoteData() {
      return this.$store.state.debitNote.debitNoteData
    },
    displayErrorDialog() {
      return this.messages
    },
    token() {
      return this.$store.state.token
    },
    isDisableddocumentNo: function() {
      return this.debitNoteForm.docAE
    },
    isBlankGSTIO: function() {
      return this.debitNoteForm.gstIO === 'B'
    },
    isGstAmtAE: function() {
      if (this.debitNoteForm.gstIO === 'B') {
        return true
      } else {
        return false
      }
    },
    isGstAmt: function() {
      return this.debitNoteForm.gstAmountAE
    },
    isNetLocAmt: function() {
      return this.debitNoteForm.netAmountLocalAE
    },
    docNoValidation() {
      return 'required|documentNo:' + this.debitNoteForm.isExistDocNo
    },
    deptValidation() {
      if (this.miscacctparams.deptMand) {
        return 'required'
      } else {
        return ''
      }
    },
    tDateRange() {
      return this.trandaterange
    },
    matchBaseCurr: function() {
      if (this.debitNoteForm.amountCurr !== null && this.debitNoteForm.amountCurr === this.baseCurrency) {
        return true
      } else {
        return false
      }
    },
    apiURI() {
      return this.$store.state.debitNote.menu
    },
    commentRefNo() {
      const data = this.$store.state.debitNote.debitNoteData
      return data.accountNo + data.documentNo + data.fund + data.suffix + data.branch + data.type
    },
    commentTranType() {
      return this.$store.state.debitNote.debitNoteData.type
    },
    isNew() {
      return !(this.debitNoteData.tranMode === 'Q' || this.debitNoteData.tranMode === 'R')
    }
  },
  methods: {
    async doInit() {
      this.loadingFlag = true
      await Promise.all([this.$store.dispatch('commonsInit')])
      await Promise.all([this.$store.dispatch('debitNoteInit')])
      this.getBaseCurr(this.debitNoteForm)
      this.getCommonData('miscacctparams').then(() => {
        this.debitNoteForm.printDocument = this.miscacctparams.defIlndr
      })
      this.getCommonData('trandaterange', '005')
      this.fetchBranch()
      this.debitNoteTranMode()
      this.fetchDepartment()
      this.fetchFund()
      this.fetchAmountCurrency()
      this.fetchAcctNoSfx60()
      this.fetchGstStatus()
      this.fetchCurrency()
      this.fetchAccount().then(() => {
        this.loadingFlag = false
      })
    },
    async debitNoteTranMode() {
      if (this.debitNoteData.tranMode === 'R') {
        await Promise.all([this.performReview()])
      } else {
        this.debitNoteForm.branch = this.token.userBranch
        this.debitNoteForm.transactionDate = new Date()
        this.debitNoteForm.transactionType = 'A'
        this.debitNoteForm.gstIO = 'B'
        this.debitNoteForm.gstStatus = 'N'
        this.debitNoteForm.addressTo = 'A'
      }
    },
    currencyChange() {
      this.debitNoteForm.gstAmountCurr = this.debitNoteForm.amountCurr
      this.debitNoteForm.netAmountCurr = this.debitNoteForm.amountCurr
    },
    changeGstIO(gstIO) {
      this.debitNoteForm.gstIO = gstIO
      if (this.debitNoteForm.gstIO === 'B') {
        this.debitNoteForm.gstStatus = 'B'
        this.debitNoteForm.gstAmount = (0.0).toFixed(2)
        this.debitNoteForm.gstRate = (0.0).toFixed(2)
      } else {
        this.debitNoteForm.gstStatus = 'M'
        this.getCommonData('gstrate', this.debitNoteForm.gstStatus, formatDisplayDateTime2(this.debitNoteForm.transactionDate))
      }
      this.calculateAmount()
    },
    setAmount() {
      this.$refs.amount.$el.cleave.setRawValue(this.debitNoteForm.amount)
      this.debitNoteForm.amount = formatPrice(this.$refs.amount.$el.cleave.getRawValue())
      this.$refs.gstAmount.$el.cleave.setRawValue(this.debitNoteForm.gstAmount)
      this.debitNoteForm.gstAmount = formatPrice(this.$refs.gstAmount.$el.cleave.getRawValue())
      this.$refs.netLocalAmount.$el.cleave.setRawValue(this.debitNoteForm.netLocalAmount)
      this.debitNoteForm.netLocalAmount = formatPrice(this.$refs.netLocalAmount.$el.cleave.getRawValue())
    },
    changeGstRate(gstStatus) {
      this.getCommonData('gstrate', gstStatus, formatDisplayDateTime2(this.debitNoteForm.transactionDate))
    },
    checkDocNo() {
      this.isDocNoExist(this.debitNoteForm)
    },
    formatDate(date) {
      return formatDisplayDate(date)
    },
    doMandatory(tabId) {
      if (this.isMandatory === false) {
        this.$validator.validateAll('debitNoteOptionalForm').then(result => {
          if (result) {
            this.isMandatory = true
            this.isOptional = false
            this.validStatus.optional = true
            this.validStatus.mandatory = true
            this.tabNav = tabId
          } else {
            if (this.isMandatory === true && this.isOptional === false) {
              this.validStatus.optional = true
              this.tabNav = 0
            } else {
              this.validStatus.optional = false
              this.tabNav = 1
            }
          }
        })
      }
    },
    doOptionalA() {
      if (this.isMandatory === false && this.isOptional === true) {
        this.validStatus.mandatory = true
        this.tabNav = 1
      } else {
        this.validStatus.mandatory = false
        this.tabNav = 0
      }
    },
    doOptional(tabId) {
      if (this.isOptional === false) {
        this.$validator.validateAll('debitNoteMandatoryForm').then(result => {
          if (result) {
            this.ValidateTranDateRange(this.debitNoteForm.transactionDate, '005').then(result => {
              if (result) {
                if (this.debitNoteData.tranMode !== 'R') {
                  this.validateIntermediary(this.debitNoteForm.transactionDate, this.debitNoteForm.accountNo).then(() => {
                    if (this.promptMsg === false || this.acceptInterWarn === true) {
                      this.isMandatory = false
                      this.isOptional = true
                      this.validStatus.mandatory = true
                      this.validStatus.optional = true
                      this.tabNav = tabId
                    } else {
                      this.doOptionalA()
                    }
                  })
                } else {
                  this.isMandatory = false
                  this.isOptional = true
                  this.validStatus.mandatory = true
                  this.validStatus.optional = true
                  this.tabNav = tabId
                }
              } else {
                this.doOptionalA()
              }
            })
          } else {
            this.doOptionalA()
            this.promptFieldCheck()
          }
        })
      }
    },
    parseDateISO(value) {
      if (value) {
        return parseISO(value)
      }
    },
    doSaveDebitNote(actionName) {
      if (this.debitNoteData.tranMode === 'R') {
        if (actionName === 'CREATE_SAVE_REVIEW') {
          actionName = 'UPDATE_SAVE_REVIEW'
        } else if (actionName === 'CREATE_SAVE_POST') {
          actionName = 'UPDATE_SAVE_POST'
        } else if (actionName === 'CREATE_MATCH_NOW') {
          actionName = 'UPDATE_MATCH_NOW'
        } else if (actionName === 'CREATE_MATCH_LATER') {
          actionName = 'UPDATE_MATCH_LATER'
        }
      }

      this.processingFlag = true

      this.$validator.validateAll('debitNoteMandatoryForm').then(result => {
        if (result) {
          this.ValidateTranDateRange(this.debitNoteForm.transactionDate, '005').then(result => {
            if (result) {
              if (this.debitNoteData.tranMode !== 'R') {
                this.validateIntermediary(this.debitNoteForm.transactionDate, this.debitNoteForm.accountNo).then(() => {
                  if (this.promptMsg === false || this.acceptInterWarn === true) {
                    this.isMandatory = false
                    this.isOptional = true
                    this.$validator.validateAll('debitNoteOptionalForm').then(result => {
                      if (result) {
                        this.isMandatory = true
                        this.isOptional = false
                        this.processingFlag = true
                        this.debitNoteForm.actionName = actionName
                        this.performSave()
                      } else {
                        this.validStatus.optional = false
                        this.processingFlag = false
                        this.tabNav = 1
                      }
                    })
                  } else {
                    this.validStatus.mandatory = false
                    this.processingFlag = false
                    this.tabNav = 0
                  }
                })
              } else {
                this.isMandatory = false
                this.isOptional = true
                this.$validator.validateAll('debitNoteOptionalForm').then(result => {
                  if (result) {
                    this.isMandatory = true
                    this.isOptional = false
                    this.debitNoteForm.actionName = actionName
                    this.performSave()
                  } else {
                    this.validStatus.optional = false
                    this.processingFlag = false
                    this.tabNav = 1
                  }
                })
              }
            } else {
              this.validStatus.mandatory = false
              this.processingFlag = false
              this.tabNav = 0
            }
          })
        } else {
          this.validStatus.mandatory = false
          this.processingFlag = false
          this.tabNav = 0
          this.promptFieldCheck()
        }
      })
    },
    doCancel() {
      this.$router.push({ name: 'debitNote' }).catch(() => {})
    },
    assignAcctInfo(data) {
      this.debitNoteForm.accountNo = data.inter
      if (this.debitNoteForm.addressTo === 'A') {
        this.debitNoteForm.gstRegNo = data.gstRegNo
        this.debitNoteForm.companyName = data.name
        this.debitNoteForm.docAddress1 = data.address1
        this.debitNoteForm.docAddress2 = data.address2
        this.debitNoteForm.docAddress3 = data.address3
        this.debitNoteForm.docAddress4 = data.address4
        this.debitNoteForm.postalCode = data.postalCode
      }
      this.showAcctNoHelpList = false
    },
    assignAcctSufInfo(data) {
      this.debitNoteForm.accountNoSuffix = data.acctNoSfx
      this.showAcctSufHelpList = false
    },
    assignCurrencyInfo(data) {
      this.debitNoteForm.amountCurr = data.curr
      this.debitNoteForm.gstAmountCurr = data.curr
      this.debitNoteForm.netAmountCurr = data.curr
      this.debitNoteForm.amountCurrRate = data.currRate
      this.showCurrencyHelpList = false
      this.calculateAmount()
    },
    assignFund(fund) {
      this.debitNoteForm.fund = fund
      this.showFundHelpList = false
    },
    assignPolicyInfo(data) {
      this.debitNoteForm.policyNo = data.policyNo + '-' + data.renCnt + '-' + data.endtCnt
      this.debitNoteForm.insuredName = data.insuredName
      this.debitNoteForm.insdRefNo = data.insdRefNo
      if (this.debitNoteForm.addressTo === 'I') {
        this.debitNoteForm.companyName = data.fullName
        this.debitNoteForm.docAddress1 = data.address1
        this.debitNoteForm.docAddress2 = data.address2
        this.debitNoteForm.docAddress3 = data.address3
        this.debitNoteForm.docAddress4 = data.address4
        this.debitNoteForm.postalCode = data.postalCode
      }
      this.showAcctPolicyHelpList = false
    },
    assignGSTRate(data) {
      this.debitNoteForm.gstRate = formatPrice(data)
      this.calculateAmount()
    },
    doRemoveNameAddr() {
      this.debitNoteForm.companyName = ''
      this.debitNoteForm.docAddress1 = ''
      this.debitNoteForm.docAddress2 = ''
      this.debitNoteForm.docAddress3 = ''
      this.debitNoteForm.docAddress4 = ''
      this.debitNoteForm.postalCode = ''
    },
    assignCurrRate(currRate) {
      this.debitNoteForm.amountCurrRate = currRate
      this.debitNoteForm.gstAmountCurr = this.debitNoteForm.amountCurr
      this.debitNoteForm.netAmountCurr = this.debitNoteForm.amountCurr
      this.calculateAmount()
    },
    async getAcctInfo(acctNo) {
      this.getCommonData('accountdata', acctNo)
    },
    assignClaimNo(claimNo) {
      this.debitNoteForm.claimNo = claimNo
      this.showClmHelpList = false
    },
    assignBaseCurr(data) {
      this.baseCurrency = data[0]
      if (this.debitNoteData.tranMode === '' && this.debitNoteForm.amountCurr === null) {
        this.debitNoteForm.amountCurr = data[0]
      }
    },
    calculateAmount() {
      if (this.baseCurrency !== '' && this.baseCurrency === this.debitNoteForm.amountCurr) {
        this.debitNoteForm.netAmountLocalAE = true
      }

      if (this.debitNoteForm.gstAmountAE) {
        this.debitNoteForm.gstAmount = formatPrice((removeFormatNumber(this.debitNoteForm.amount) * this.debitNoteForm.gstRate) / 100)
      }

      if (this.debitNoteForm.gstIO === 'B') {
        this.debitNoteForm.netAmount = formatPrice(Number(removeFormatNumber(this.debitNoteForm.amount)))
      } else if (this.debitNoteForm.gstIO === 'I') {
        this.debitNoteForm.netAmount = formatPrice(
          Number(removeFormatNumber(this.debitNoteForm.amount)) + Number(removeFormatNumber(this.debitNoteForm.gstAmount))
        )
      } else if (this.debitNoteForm.gstIO === 'O') {
        this.debitNoteForm.netAmount = formatPrice(
          Number(removeFormatNumber(this.debitNoteForm.amount)) + Number(removeFormatNumber(this.debitNoteForm.gstAmount))
        )
      }
      /* Since netLocalAmountCurr is set same with amountCurr then the netLocalAmountCurrRate is same with amountCurrRate */
      if (this.debitNoteForm.netAmountLocalAE) {
        this.debitNoteForm.netLocalAmount = formatPrice(Number(removeFormatNumber(this.debitNoteForm.netAmount)) * this.debitNoteForm.amountCurrRate)
      }
      this.setAmount()
    },
    assignMatchLaterInfo(data) {
      this.debitNoteForm.bmAcctNo = data.bmAcctNo
      this.debitNoteForm.bmAcctNoSfx = data.bmAcctNoSfx
      this.debitNoteForm.bmBrn = data.bmBrn
      this.debitNoteForm.bmFund = data.bmFund
      this.debitNoteForm.bmTranType = data.bmTranType
      this.debitNoteForm.bmDocNo = data.bmDocNo
      this.showMatchLater = false
      this.doSaveDebitNote('CREATE_MATCH_LATER')
    }
  },
  created() {
    this.$validator.extend('documentNo', {
      getMessage(field, args) {
        return 'This document no. is exist.'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var isdocNoExist = args[0]
        if (isdocNoExist === 'true') {
          return false
        } else {
          return true
        }
      }
    })
    this.$validator.extend('valMaxTranDate', {
      getMessage(field, args) {
        return 'This date cannot be greater than the date range ' + formatDisplayDate(args[0])
      },
      validate(value, args) {
        let maxDate = args[0]
        if (value) {
          return !isAfter(removeTime(value), removeTime(maxDate))
        } else return true
      }
    })
    this.$validator.extend('valMinTranDate', {
      getMessage(field, args) {
        return 'This date cannot be lesser than the date range ' + formatDisplayDate(args[0])
      },
      validate(value, args) {
        let minDate = args[0]
        if (value) {
          return !isAfter(removeTime(minDate), removeTime(value))
        } else return true
      }
    })
  },
  mounted() {
    this.doInit()
  },
  mixins: [routeMixin, MessageMixin, debitNoteAjaxMixin, debitNoteViewMixin, commonAjaxMixin, promptOnExitMixin],
  components: {
    AcctNoHelpList,
    AcctSufHelpList,
    CurrencyHelpList,
    AcctPolicyHelpList,
    ClaimHelpList,
    FundHelpList,
    PromptLeave,
    SanctionPartialMatchList,
    MatchLater,
    CommonComments
  }
}
</script>
<style lang="scss">
@import '../../../../assets/scss/accounting.scss';
</style>
